import { render, staticRenderFns } from "./ListVTPage.vue?vue&type=template&id=4f8a8e7e&scoped=true&"
import script from "./ListVTPage.vue?vue&type=script&lang=js&"
export * from "./ListVTPage.vue?vue&type=script&lang=js&"
import style0 from "./ListVTPage.vue?vue&type=style&index=0&id=4f8a8e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8a8e7e",
  null
  
)

export default component.exports